import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';

import { default as WidgetCustomModel } from '../../models/widget-custom';

import useAppContext from '../../context/useAppContext';
import { ToastContext, Button, WeezHeader } from '@weezevent/nacre';

import { useTranslation } from 'react-i18next';

import WidgetCustomInputs from './widget-custom-inputs';

export default function WidgetCustom({ widgetId, history }) {
    const [{ organization }] = useAppContext();
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();

    const [, setLoading] = React.useState(false);
    const [customs, setCustoms] = React.useState(false);

    React.useEffect(() => {
        setLoading(true);
        WidgetCustomModel.getAll({
            organizationId: organization.id,
            widgetId
        })
            .then(([custom]) => {
                setCustoms(custom.values);
            })
            .catch(e => {
                if (e.statuscode && e.code === 404) {
                    return;
                }
                toast.error(t('ticket.widget.custom.retrieval_error'));
            })
            .finally(e => {
                setLoading(false);
            });
    }, []);

    const save = React.useCallback(() => {
        let custom = new WidgetCustomModel({ values: customs });
        custom
            .save({
                organizationId: organization.id,
                widgetId
            })
            .then(() => {
                toast.success(t('ticket.widget.custom.save_success'));
                history.push(`/ticket/O${organization.id}/widgets`);
            })
            .catch(e => {
                Sentry.configureScope(scope => {
                    scope.setExtra('widget_id', widgetId);
                });
                Sentry.captureException(e);
                toast.error(t('ticket.widget.custom.save_error'));
            });
    }, [customs, history]);

    const onBack = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/widgets`);
    }, [history]);

    let { css, ...values } = customs;
    return (
        <div>
            <WeezHeader
                backLink={{ onClick: onBack }}
                title={t('ticket.widget.custom.title')}
                rightComponent={<Button primary label={t('ticket.common.action.save')} onClick={save} />}
            />
            <WidgetCustomInputs className="widget-custom-inputs" values={values} css={css} onChange={setCustoms} />
        </div>
    );
}

WidgetCustom.propTypes = {
    widgetId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired
};
